import React, { Fragment, useEffect, useState, useRef } from 'react'
import DataGrid, {Pagenation} from '../../../../components/dataGrid'
import tremApi from '../../../../util/tremApi'
import G from '../../../../util/globalFunction'

export default props => {
    const {
        SINGLE_MODE, 
        EQUIP_SKEY = null, 
        setStoredValue
    } = props?.modalprops || {}

    const [dataStore, setDataStore] = useState({
        data : [],
        totalCount:0,
        page:0, 
        pageCount : 5
    })
    const { data, totalCount, pageCount, page} = dataStore
   
    const inputNameRef = useRef(null)

    useEffect(() => {
        setGrid(1)
    },[])

    const setGrid = async props =>{
        const gridProps = {
            EQUIP_SKEY: EQUIP_SKEY,
            NAME: inputNameRef?.current?.value || '',
            page: props,
            rows:5
        }
        
        const expertList = await tremApi('/r/expert/list', G.removeEmptyUndefinedOrNull(gridProps))
        
        if(!expertList) {
            alert(G.t('trem.lang.home.0836'))/* 오류발생 */
        }

        const totalCount = expertList.total
        const pageCount = dataStore.pageCount
        const page = dataStore.page || 0
        const data = expertList.rows.slice(page * pageCount, (page + 1) * pageCount)
        setDataStore({...dataStore, totalCount, pageCount, page, data }) 
    }
    
    // 페이지 이동
    const hangleChangePage = page => {
        setGrid(page+1)
    }

    //조회
    const searchBtn = () =>{
        setGrid(1)
    }

    const pageNationsInfo = { totalCount, pageCount, page, hangleChangePage }

    return (
        <div>
            <table className="popup_table_type1" style={{marginBottom: '10px'}}>
                <caption>전문가 선택 팝업 검색 표 - 성명으로 구성</caption>
                <tbody>
                    <tr>
                        <th scope='row'><label htmlFor="NAME">{G.t('trem.lang.home.0181')}</label></th>{/* 성명 */}
                        <td>
                            <input title="성명 입력" id="NAME" type="text" name="NAME" onKeyPress={e => {if(e.key === 'Enter') searchBtn()}} ref={inputNameRef} />
                        </td>
                    </tr>
                </tbody>
            </table> 
            <div className="text-right btn_type4 mb-6">
                <a href="javascript:void(0);" onClick={searchBtn} className="red">조회</a>
            </div>
            <DataGrid data={data}>
                <div title={G.t('trem.lang.home.0200')}/* 선택 */
                    type="string" align="left" width="1fr" sort={false} filter={false} className="font-semibold"
                    render = {(row, rowIndex, columnIndex, field)=>{
                        return(
                            <input
                                title="선택"
                                type="checkbox"
                                name="deptCheckBox"
                                onKeyDown={(e)=>{
                                    if(e.code==="Enter"){
                                        const inputCheckboxes = document.getElementsByName('deptCheckBox')
                                        for(let inputCheckbox of inputCheckboxes) {
                                            inputCheckbox.checked = false
                                        }
                                        inputCheckboxes[rowIndex].checked = true
    
                                        setStoredValue(row)
                                    }
                                }}
                                onChange={() => { 
                                    const inputCheckboxes = document.getElementsByName('deptCheckBox')
                                    for(let inputCheckbox of inputCheckboxes) {
                                        inputCheckbox.checked = false
                                    }
                                    inputCheckboxes[rowIndex].checked = true

                                    setStoredValue(row)
                                }}
                            />
                        )
                    }
                }/>
                <div title={G.t('trem.lang.home.0181')}       field="NAME_KOR"    type="string" align="center" width="1fr" sort={false} filter={false}/>{/* 성명 */}
                <div title={G.t('trem.lang.home.0181')+"("+G.t('trem.lang.home.0478')+")"} field="NAME_ENG"    type="string" align="center" width="1fr" sort={false} filter={false}/>{/* 성명(영문) */}
                <div title="직위"       field="POSITION"    type="string" align="center" width="1fr" sort={false} filter={false}/>
                <div title={G.t('trem.lang.home.0038')}       field="COMPANY_NAME"type="string" align="center" width="1fr" sort={false} filter={false}/>{/* 소속 */}         
                <div title="부서"       field="DEPT_NAME"   type="string" align="center" width="1fr" sort={false} filter={false}/>
                <div title={G.t('trem.lang.home.0190')}   field="SP_CONTENTS" type="string" align="center" width="1fr" sort={false} filter={false}/>{/* 특이사항 */}
            </DataGrid>
            
            
            <div className="self-center">
                <Pagenation {...pageNationsInfo} />
            </div>
        </div>
    )
}